<div id="hotelbooking" class="registration container">
  <form #hotelbookingForm="ngForm" [ngClass]="{'form-complete': hotelbookingForm.valid}" name="hotelbookingForm" (ngSubmit)="forward(hotelbookingForm)" novalidate autocomplete="off" appScrollToInvalid [ngClass]="{'form-complete': isFormCompleted}">
    <h1>{{ 'copy.label.HOTEL.heading' | copy | async }}</h1>

    <section class="card" *ngIf="soldout === true">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.HOTEL.label' | copy | async }}
        </div>
      </div>
      <article>
        <div class="w-100" [innerHTML]='"copy.html.soldouttext" | copy | async'></div>
      </article>
    </section>

    <section class="card" *ngIf="soldout === false">
      <div class="card-header">
        <div class="card-title ml-0">
          {{ 'copy.label.HOTEL.label' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <div *ngIf="attendee.PAXTypeNo === 20" class="w-100" [innerHTML]='"copy.html.sdemployeetext" | copy | async'></div> 
        <div *ngIf="varTrack.Value==='Home Office' && attendee.PAXTypeNo !== 29" class="w-100" [innerHTML]='"copy.html.hoHotelNote" | copy | async'></div>

        <mat-radio-group [(ngModel)]="enrollment.HotelNeeded" name="hotelNeeded" #hotelNeeded="ngModel" required (ngModelChange)="clearRequests()">
          <mat-radio-button [value]="true" [checked]="enrollment.HotelNeeded === true">Yes</mat-radio-button>
          <mat-radio-button [value]="false" [checked]="enrollment.HotelNeeded === false">No</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation  [object]="hotelNeeded" isRequired=true ></app-validation></mat-error>
          </div>
        </mat-radio-group>
        <div *ngIf="enrollment.HotelNeeded === true" class="w-100" [innerHTML]='"copy.html.hotelpdfs" | copy | async'></div>
        <div *ngIf="enrollment.HotelNeeded === true && (attendee.PAXTypeNo !== 26 && attendee.PAXTypeNo !== 40 && attendee.PAXTypeNo !== 23 && attendee.PAXTypeNo !== 24 && attendee.PAXTypeNo !== 21 && attendee.PAXTypeNo !== 29 )" class="w-100" [innerHTML]='"copy.html.hotelpdfs2" | copy | async'></div>
        <div *ngIf="enrollment.HotelNeeded === true && (varTrack.Value === 'Benefit Advisor' || varTrack.Value==='Non-Benefit Advisor')" class="w-100" [innerHTML]='"copy.html.hotelpdfs3" | copy | async'></div>
        <mat-label *ngIf="enrollment.HotelNeeded === true && varBenefitRoomNights.Value > 0 && varTrack.Value === 'Benefit Advisor'" class="w-100 font-weight-bold">Your {{varBenefitLevel.Value}} club level entitles you to {{varBenefitRoomNights.Value}} complimentary room night(s).</mat-label>
        <mat-label *ngIf="enrollment.HotelNeeded === true && varBenefitRoomNights.Value > 0 && (attendee.PAXTypeNo == 23 || attendee.PAXTypeNo == 24)" class="w-100 font-weight-bold">Your invitation includes {{varBenefitRoomNights.Value}} complimentary room night(s).</mat-label>
        <!-- <div *ngIf="enrollment.HotelNeeded === true && (attendee.PAXTypeNo === 21 || attendee.PAXTypeNo === 29)" class="w-100" [innerHTML]='"copy.html.hotelhomeoffice" | copy | async'></div> -->
      </article>
    </section>


    <section class="card" *ngIf="enrollment.HotelNeeded === true">
      <div class="card-header">
        <div class="card-title ml-0">
          {{ 'copy.label.HOTEL.makereservation' | copy | async }}
        </div>
      </div>
      <article>
        <div class="w-100" [innerHTML]='"copy.html.reservationtext" | copy | async'></div>

        <div *ngIf="attendee.PAXTypeNo !== 40" class="w-100" [innerHTML]='"copy.html.datenote" | copy | async'></div>
        <!-- <div *ngIf="attendee.PAXTypeNo === 21 || attendee.PAXTypeNo === 29" class="w-100" [innerHTML]='"copy.html.datenotehomeoffice" | copy | async'></div> -->
        <div *ngIf="varBenefitRoomNights.Value > 0  && (varTrack.Value === 'Benefit Advisor' || attendee.PAXTypeNo == 23 || attendee.PAXTypeNo == 24)" class="w-100" [innerHTML]='"copy.html.benefitroomtext" | copy | async'></div>

      </article>
    </section>

    <section class="card" *ngIf="enrollment.HotelNeeded === true">
      <div class="card-header">
        <div class="card-title ml-0">
          {{ 'copy.label.HOTEL.hotels' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <div class="error ng-invalid" *ngFor="let error of getNonContiguousHotels()">
          <strong><span class="fas fa-stack"><i class="fas fa-exclamation fa-stack-1x"></i><i class="fas fa-circle-thin fa-stack-2x"></i></span> Rooms selected not contiguous for {{error}}. </strong>
        </div>
        <div class="error ng-invalid" [hidden]="!noHotel">
          <strong><span class="fas fa-stack"><i class="fas fa-exclamation fa-stack-1x"></i><i class="fas fa-circle-thin fa-stack-2x"></i></span>Please select at least one hotel room.</strong>
        </div>
        <mat-checkbox *ngIf="enrollment.HotelNeeded === true && hotelList != undefined && hotelList.roomTypeList.length > 1" name="soldOutFilter" [(ngModel)]="hideSoldOutHotels">
          <div name="soldOutFilterLabel" id="soldOutFilter">{{ 'copy.label.HOTEL.hotelFilter' | copy | async }}</div>
        </mat-checkbox>
        <span class="w-100" style="border-bottom: 1px solid #777"></span>
        <div class="table-responsive">
          <table class="table hotelTable" *ngIf="hotelList != undefined">
            <thead>
              <tr>
              <th></th>
              <th *ngIf="this.preextend > 0" class="extension extension-header" [attr.colspan]="preextend">Pre Extension</th>
              <th *ngIf="this.groupDays > 0" class="eventDates" [attr.colspan]="groupDays + 1">Event Dates</th>
              <th *ngIf="this.postextend > 0" class="extension extension-header" [attr.colspan]="postextend">Post Extension</th>
              </tr>
            </thead>

            @for(hotelobj of hotelList.roomTypeList; track hotelobj.webHotelGroupID){
            <tbody *ngIf="!soldOutHotels.includes(hotelobj.webHotelGroupID) || !hideSoldOutHotels">
              <tr>
                <th class="hotelDetails"><h2>{{hotelobj.displayName}}</h2>
                  <!-- <a class="desktopDetails" ng-if="!hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.showdetails"|copy|async}}</a>
                  <a class="desktopDetails" ng-if="hotelobj.displaySection" (click)="hotelCtrl.showSection(hotelobj)">{{"copy.label.HOTEL.BOOKING.hidedetails"|copy|async}}</a> -->
                </th>
                <th *ngFor="let n of dateRange"><span class="day">{{n|date:"EEE": "-0500"}}</span><span class="date">{{n| date:"MMM d": "-0500"}}</span></th>
              </tr>
              <tr>
                <td class="hotelDetails">
                  <p>
                    <a class="mobileDetails" (click)="showModal(hotelobj)">{{"copy.label.HOTEL.BOOKING.mobiledetails"|copy|async}}</a>
                  </p>
                  <p><strong>{{hotelobj.distance}}</strong></p>
                </td>
                <td *ngFor="let n of hotelobj.roomNightsListWithRate" [ngClass]="{'prepost': n.groupDateFlag!=='GRP'}">
                  <div class="d-flex justify-content-center flex-column align-items-center" *ngIf="isHotelAvailableOnDate(hotelobj, n.blockDate) && !n.isBookedAsPending">
                    <!-- <input type="checkbox" [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" (click)="addNight(n.blockDate, hotelobj.webHotelGroupID)"> -->
                    <mat-checkbox style="position: relative; z-index: 100;"
                    [disabled] = "pickedHotel !== undefined && pickedHotel != hotelobj.webHotelGroupID "
                    [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)"
                    [unchecked] = "unchecked()"
                    (change)="addNight(n.blockDate, hotelobj.webHotelGroupID)">


                </mat-checkbox>
                    <div class="hotel_desc" *ngIf="n.nightNetRate !== 0">{{n.nightNetRate| currency}} </div>
                    <div class="hotel_desc" *ngIf="n.netRateAltText">{{n.netRateAltText}} </div>
                  </div>
                  <div class="d-flex justify-content-center flex-column align-items-center" *ngIf="isHotelAvailableOnDate(hotelobj, n.blockDate) && n.isBookedAsPending">
                    <!-- <input type="checkbox" [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)" (click)="addNight(n.blockDate, hotelobj.webHotelGroupID)"> -->
                    <mat-checkbox style="position: relative; z-index: 100;"
                      [disabled] = "(pickedHotel !== undefined && pickedHotel != hotelobj.webHotelGroupID)"
                      [checked]="isChecked(n.blockDate, hotelobj.webHotelGroupID)"
                      (change)="addNight(n.blockDate, hotelobj.webHotelGroupID)">

                </mat-checkbox>
                    <div class="hotel_desc" *ngIf="n.nightNetRate !== 0">{{n.nightNetRate| currency}} </div>
                    <div class="hotel_desc" *ngIf="n.netRateAltText">{{n.netRateAltText}} </div>
                  </div>
                  <div class="d-flex justify-content-center flex-column align-items-center" *ngIf="!isHotelAvailableOnDate(hotelobj, n.blockDate)">
                    <span class="material-icons">
                      clear
                    </span>
                    <div class="hotel_desc">{{"copy.label.HOTEL.BOOKING.notavail"|copy|async}} </div>
                  </div>
                </td>
              </tr>
              <tr>&nbsp;&nbsp;</tr>
            </tbody>
            }
          </table>
        </div>
      </article>
    </section>
    <section class="card" *ngIf="enrollment.HotelNeeded === true">
      <div class="card-header">
        <div class="card-title ml-0">
          {{ 'copy.label.HOTEL.roominfo' | copy | async }}
        </div>
      </div>
      <article>
        <!-- {{ 'copy.label.HOTEL.roompref' |copy |async}} -->
        
        <!-- <div>
          {{ 'copy.label.HOTEL.special' |copy |async}}
          <textarea name="hotelSpecialRequests" [(ngModel)]="enrollment.HotelSpecialRequests" maxlength="225"></textarea>
        </div> -->
        <div class="d-flex justify-content-start w-100">
          <mat-form-field class="w-100">
            <mat-label class="w-100" for="DietaryNeedOther" aria-labelledby="DietaryNeedOther">{{ 'copy.label.HOTEL.special' |copy |async}}</mat-label>
            <textarea matInput class="w-100" name="hotelSpecialRequests" [(ngModel)]="enrollment.HotelSpecialRequests" maxlength="225" pattern="^[\w\s!@\-\_:&',.\/?]*"></textarea>
          </mat-form-field>
        </div>
        <div class="d-flex justify-content-start w-100">
          <mat-form-field class="w-100">
            <mat-label for="hotelrewards" aria-labelledby="hotelrewards" [ngClass]="{'active' : varHotelRewards.Value}">{{ 'copy.label.HOTEL.hotelrewards' | copy | async }}</mat-label>
            <input matInput name="hotelrewards" id="hotelrewards" [attr.aria-label]="hotelrewards" type="text" class="form-control" maxlength="35" pattern="^[\w\s!@\-\_\\:',.\/?]*" [(ngModel)]="varHotelRewards.Value" #hotelrewards="ngModel"  />
            <mat-error><app-validation  [object]="hotelrewards" isRequired=true pattern="alphanum"></app-validation></mat-error>
          </mat-form-field>
        </div> 
      </article>
  </section>

    <section class="card" *ngIf="enrollment.HotelNeeded === false && soldout === false">
      <div class="card-header">
        <div class="card-title">
          {{ 'copy.label.DEMOGRAPHICS.nohotellabel' | copy | async }}
          <i class="fas fa-asterisk required"></i>
        </div>
      </div>
      <article>
        <mat-radio-group [(ngModel)]="enrollment.HotelSpecialRequests" name="noHotelReason" #noHotelReason="ngModel" required>
          <mat-radio-button *ngFor="let op of noHotelRadios" [value]="op.value">{{op.display}}</mat-radio-button>
          <div class="w-100">
            <mat-error><app-validation  [object]="noHotelReason" isRequired=true ></app-validation></mat-error>
          </div>
        </mat-radio-group>

        <div *ngIf="enrollment.HotelSpecialRequests === 'Sharing a room reserved by someone else'">
          <mat-label>{{ 'copy.label.HOTEL.roommatequestion' | copy | async }}</mat-label>
          <mat-form-field class="w-100">
            <mat-label for="roommatefirst" aria-labelledby="roommatefirst" [ngClass]="{'active' : varRoommateFN.Value}">{{ 'copy.label.HOTEL.roommatefirst' | copy | async }}</mat-label>
            <input matInput name="roommatefirst" id="roommatefirst" [attr.aria-label]="roommatefirst" type="text" class="form-control" maxlength="100" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="varRoommateFN.Value" #roommatefirst="ngModel" required />
            <mat-error><app-validation  [object]="roommatefirst" pattern="alpha"></app-validation></mat-error>
          </mat-form-field>
          <mat-form-field class="w-100">
            <mat-label for="roommatelast" aria-labelledby="roommatelast" [ngClass]="{'active' : varRoommateLN.Value}">{{ 'copy.label.HOTEL.roommatelast' | copy | async }}</mat-label>
            <input matInput name="roommatelast" id="roommatelast" [attr.aria-label]="roommatelast" type="text" class="form-control" maxlength="100" pattern="^[A-Za-z\s\-\_'.]*$" [(ngModel)]="varRoommateLN.Value" #roommatelast="ngModel" required />
            <mat-error><app-validation  [object]="roommatelast" pattern="alpha"></app-validation></mat-error>
          </mat-form-field>
        </div>

      </article>
    </section>
    <div class="button_group d-flex">
      <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting && varLoginID.Value !== 'hotelinventory'">
        <!-- <i class="material-symbols-outlined icon-align">chevron_left</i> -->
        {{ 'copy.label.GLOBAL.goback' | copy | async }}
      </button>
      <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting && varLoginID.Value !== 'hotelinventory'">
        {{ 'copy.label.GLOBAL.continue' | copy | async }}
        <!-- <i class="material-symbols-outlined icon-align">chevron_right</i> -->
      </button>
      <button class="inputSubmit btn btn-primary ml-auto" *ngIf="isSubmitting">
        <i class="fas fa-spinner fa-spin"></i>
      </button>
    </div>
  </form>
</div>
